<!-- 需要售后的销售单 -->
<template>
    <div class="searchAp-ctn" id="selectAfterSaleOrder">
        <div class="search-ctn">
            <div class="search-ctn-left" style="margin-top: 10px">
                <div class="flex">
                    <div class="search-name">客户</div>
                    <div>
                        <el-select
                            class="search-item"
                            size="small"
                            v-model="searchData.Keyword"
                            remote
                            filterable
                            allow-create
                            placeholder="客户名称"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">销售单号</div>
                    <el-input v-model="searchData.OrderCode" class="search-item" size="small" style="width: 180px"></el-input>
                    <div class="search-name">业务员</div>
                    <div>
                        <el-select
                            v-model="searchData.SId"
                            filterable
                            clearable
                            remote
                            size="small"
                            placeholder="选择业务员"
                            @visible-change="siVisibleChange($event)"
                            style="width: 120px"
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">创建时间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" @click="chooseOrder()">确定</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                v-loading="loading"
                :header-cell-style="selectionStyle"
                :data="tableData"
                border
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                @cell-dblclick="handleDBClick"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column type="selection" :selectable="selectInit"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="OrderCode" label="销售单号"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="160px" prop="EntpCusName" label="客户"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="CallNum" label="电话号码"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="OutWarehouseStateName" label="物流状态"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="InMoneyStateName" label="收款状态"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="OrderAmount" label="销售总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="TotalBillingPrice" v-if="isBPriceShow" label="开单总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" label="相关售后">
                    <template slot-scope="scope">
                        <div class="ordercodediv" v-if="scope.row.ReturnOrderList.length > 0">
                            <el-tag class="codetag" v-for="(item, index) in scope.row.ReturnOrderList" :key="index">{{ item}}</el-tag>
                        </div>
                        <div class="ordercodediv" v-else>无</div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="SName" label="业务员"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="CreateTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn" style="padding: 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" :append-to-body="true" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="searchOrderVisible" width="1000px" v-dialog-drag :modal="false" lock-scroll id="search-dialog">
            <div v-if="searchOrderVisible">
                <SearchOrderAP
                    dragSign="SearchOrderReturnAP"
                    :EntpCusOId="entpCusOId"
                    :EntpCusName="entpCusName"
                    @closeDialog="
                        () => {
                            searchOrderVisible = false;
                        }
                    "
                ></SearchOrderAP>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import timePicker from '@/components/common/timePicker';
import SearchOrderAP from '@/components/common/APSaleOrderDetail';
export default {
    name: '',
    props: [],
    components: { timePicker, SearchOrderAP },
    data() {
        return {
            multipleSelection: null,
            timeVisible: false,
            loading: false,
            entpCusOId: '',
            entpCusName: '',
            title: '',
            searchOrderVisible: false,
            searchData: {
                Keyword: '',
                OrderCode: '',
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            customerList: [],
            SIdList: [],
            idList: [],
            tableDataLength: 0,
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isBPriceShow: false
        };
    },
    created() {
        this.getSysConfig();
    },
    mounted() {
        this.getTableData();
        this.searchCustom();
        let dialogbody = document.querySelector('#selectAfterSaleOrder');
        this.$util.setEventForDialog(this, dialogbody);
    },
    methods: {
        getSysConfig() {
            this.$util.getSysConfig('xskdxskdj').then(data => {
                this.isBPriceShow = data.Result;
            });
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        selectionStyle(obj) {
            if (obj.columnIndex == 0) obj.column.renderHeader = null;
            return 'background: #f2f6fc;';
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 选择配件
        chooseOrder() {
            //这里还要进行判断
            //1.判断不能为空
            //2.判断企业必须同一个
            //3.判断地址必须同一个
            if (this.idList && this.idList.length > 0) this.$emit('closeDialog', this.idList);
            else this.$util.warningMsg('请选择需要售后的销售单 ^_^');
        },
        resetSearch() {
            this.searchData = {
                Keyword: '',
                OrderCode: '',
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            };
            this.searchCustom('');
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetEnterpriseSaleAfterOrderList',
                    data: this.searchData,
                    hideLoading:true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    if (this.searchData.page == 1) {
                        this.tableDataLength = res.count;
                    }
                });
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                if (row.EntpCusOId == this.idList[0]) {
                    return true;
                } else {
                    return false;
                }
            } else return true; //可勾选
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
            }
            this.idList = idList;
        },
        handleDBClick(item) {
            if (item) {
                this.searchOrderVisible = true;
                this.entpCusOId = item.EntpCusOId;
                this.entpCusName = item.EntpCusName;
                this.title = item.EntpCusName + '【' + item.OrderCode + '】';
            }
        }
    }
};
</script>
<style lang="less" scoped>
.ordercodediv {
    display: flex;
    flex-direction: column;
    .codetag {
        font-size: 12px;
        border-style: none none none none;
        background-color: transparent;
        padding: 0;
    }
}
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    padding-bottom: 10px;
    overflow-y: auto;
}
</style>
